$(function(){
  $('input').prop('checked', false);

  var diagnosis = $('#diagnosis').slick({
    adaptiveHeight: true,
    autoplay: false,
    dots: false,
    arrows: false,
    draggable: false,
    infinite: false,
    swipe: false,
    touchMove: false,
    fade: true,
    speed:0
  });
  const score = {
    'axis1': 0,
    'axis2': 0,
    'axis3': 0,
  }
  const result = {
    'challenger': 16,
    'innovator': 17,
    'pioneer': 18,
    'humanist': 19,
    'professor': 20,
    'translator': 21,
    'creator': 22,
    'connector': 23,
  }
  let resultType = '';
  $('[data-goto]').on('click', function(){
    const goto = $(this).data('goto');
    if (goto === 4) {
      diag();
    }
    diagnosis.slick('slickGoTo', goto);
    $('.diagnosis-panel').scrollTop(0);
  });

  function diag(){
    $('input:checked').each(function(i, element){
      const name = $(element).data('name').split('_');
      score[name[0]] += parseInt($(element).val());
      // console.log(name);
      // console.log($(element).val());
      // console.log(score);
    })
    if (score['axis1'] > 0 && score['axis2'] > 0 && score['axis3'] > 0) {
      resultType = 'challenger';
    } else if (score['axis1'] > 0 && score['axis2'] > 0 && score['axis3'] < 0) {
      resultType = 'architecture';
    } else if (score['axis1'] > 0 && score['axis2'] < 0 && score['axis3'] > 0) {
      resultType = 'pioneer';
    } else if (score['axis1'] > 0 && score['axis2'] < 0 && score['axis3'] < 0) {
      resultType = 'humanist';
    } else if (score['axis1'] < 0 && score['axis2'] > 0 && score['axis3'] > 0) {
      resultType = 'professor';
    } else if (score['axis1'] < 0 && score['axis2'] > 0 && score['axis3'] < 0) {
      resultType = 'ambassador';
    } else if (score['axis1'] < 0 && score['axis2'] < 0 && score['axis3'] > 0) {
      resultType = 'organizer';
    } else if (score['axis1'] < 0 && score['axis2'] < 0 && score['axis3'] < 0) {
      resultType = 'connector';
    }
    // console.log(score);
    // console.log(resultType);
    $('input[name="entry.1285755372"]').val(resultType);
    sessionStorage.setItem('result', resultType);
    // return false;
  }

  $('[data-retry]').on('click', function(){
    $('input').prop('checked', false);
    let url = new URL(window.location.href);
    url.searchParams.delete('result');
    window.history.pushState({}, '', url);
    diagnosis.slick('slickGoTo',0);
    score['axis1'] = 0;
    score['axis2'] = 0;
    score['axis3'] = 0;
    resultType = '';
    return false;
  });

  const sampleParams = new URLSearchParams(window.location.search);
  if (sampleParams.get('result')) {
    const type = sampleParams.get('result')
    diagnosis.slick('slickGoTo',result[type]);
  }

  $('input[type="radio"]').on('change', function(){
    const name = $(this).data('name').split('_');
    const nextNumber = parseInt(name[1].slice(1)) + 1;
    $('#q' + nextNumber).removeClass('diagnosis-question-disabled');
    const nextPage = Math.floor(nextNumber/5);
    // console.log(nextPage)

    if (nextNumber % 5 === 1) {
      $('[data-next="' + nextPage + '"]').removeClass('diagnosis-question-disabled');
    }
  });

});
